import { createSlice } from '@reduxjs/toolkit';
import { getVacancies } from '../actions';
import { Vacancy } from '../actions/types';

export interface InitialState {
    items: Vacancy[];
    items_total: number;
}

const initialState: InitialState = {
    items: [],
    items_total: 0
}

export const vacanciesSlice = createSlice({
    name: 'vacancy',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getVacancies.fulfilled, (state, action) => {
            state.items = action.payload.items;
            state.items_total = action.payload.items_total;
        });
        
    }
})

export default vacanciesSlice.reducer;
